import React from "react";
import useTableData from "./useTableData";
import ListViewCommon from "./ListViewCommon";

const headers = [
    {"label": "SNR", 'filter': 'string'},
    {"label": "Typ", "caption": "Typ", 'filter': 'string'},
    {"label": "Nazov", "caption": "Názov", 'filter': 'string'},
    {"label": "Stav", 'filter': 'string'},
    {"label": "Zakaznik", "caption": "Zákazník", 'filter': 'string'},
    {"label": "Datum_Vyroby", "caption": "Dátum Výroby", 'filter': 'dateRange'},
    {"label": "Zaruka", "caption": "Záruka", 'filter': 'dateRange'},
    {"label": "Demo", 'filter': 'bool'},
]

function Instruments(props) {
    const initialFilters = [
        {
            'label': 'SNR',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zaruka_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zaruka_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Vyroby_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Vyroby_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Demo',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Typ',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zakaznik',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Stav',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Meno',
        }
    ]
    const baseUrl = '/instrument/instruments'
    const exportUrl = baseUrl + '/export/'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'SNR': `/instruments/instrument/${entry.id}`,
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={`/instruments/instrument`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Prístroje"}
                        exportButton={true}
                        exportUrl={exportUrl}
        />
    )
}

export default Instruments
